import { AnyAction } from 'redux';
import { ThunkDispatch } from 'store/store';
import State from 'store/State';
import Services from 'store/Services';

import {
    PortfolioActionType,
    PortfolioSetActiveInputAction,
} from 'portfolio/store/actions';
import { ActiveInputType } from 'portfolio/PortfolioState';
import { WidgetInfo } from 'widgets/WidgetInfo';

export type ClearActivePortfolioSelectionAsyncThunk = (
    dispatch: ThunkDispatch<AnyAction>,
    _getState: () => State,
    { portfolioService }: Services
) => Promise<void>;

export const clearActivePortfolioSelectionAsync: () => ClearActivePortfolioSelectionAsyncThunk =

        () =>
        async (_dispatch, _getState, { portfolioService }) => {
            portfolioService.clearSelection();
        };

export type PortfolioSetActiveInputActionAsyncThunk = (
    dispatch: ThunkDispatch<PortfolioSetActiveInputAction>
) => Promise<void>;

/*
 * Asyncronously dispatch the PORTFOLIO_SET_ACTIVE_INPUT action
 * As well as updating the state this will be handled by middleware such as order filter middleware
 */
export const portfolioSetActiveInputActionAsync: (
    activeInputType: ActiveInputType,
    activeInputWidget?: WidgetInfo
) => PortfolioSetActiveInputActionAsyncThunk =
    (activeInputType, activeInputWidget?) => async (dispatch) => {
        dispatch({
            type: PortfolioActionType.PORTFOLIO_SET_ACTIVE_INPUT,
            payload: {
                activeInputType,
                activeInputWidget,
            },
        });
    };
